import { defineComponent as _defineComponent } from 'vue'
import { ref, onUnmounted, onMounted, computed } from 'vue';
import FileWrapperMultiViewInfo from './FileWrapperMultiViewInfo.vue';
import FileWrapperMultiViewTabs from './FileWrapperMultiViewTabs.vue';
import FileWrapperRejection from './FileWrapperRejection.vue';
import FileWrapperApplicant from './FileWrapperApplicant.vue';
import useFileWrapperMultiView, { createService, destroyService } from '../../composables/use-file-wrapper-multi-view';
import { Icon as PtIcon } from 'patsnap-biz';
import _ from 'lodash';
import PtNodata from '../PtNodata.vue';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileWrapperMultiView',
  props: {
    patentId: {
        type: String,
        required: true,
    },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props

window.rvTrack('View Patent File Wrapper Multi View');

const {
    multiViewNodata,
    multiViewTabList,
    currentRound,
    currentRoundDetail,
} = useFileWrapperMultiView();



const rootElement = ref<HTMLElement | null>(null);


const onClose = () => {
    emit('close', undefined);
};

const moveElementToBody = () => {
    if (rootElement.value) document.body.appendChild(rootElement.value);
};

const removeElementInBody = () => {
    if (rootElement.value) document.body.removeChild(rootElement.value);
};

const escapeHandler = e => {
    if (e.key === 'Escape' || e.keyCode === 27) {
        onClose();
    }
};
document.addEventListener('keydown', escapeHandler);
onMounted(() => {
    moveElementToBody();
});
onUnmounted(() => {
    document.removeEventListener('keydown', escapeHandler);
    destroyService();
    removeElementInBody();
});

const showTabsMore = ref(false);
const loading = ref(true);

createService(props.patentId)
    .then(() => {
        loading.value = false;
    });

const currentRoundNodata = computed(() => {
    return _.isEmpty(currentRoundDetail.value);
});

return { __sfc: true,multiViewNodata, multiViewTabList, currentRound, currentRoundDetail, props, rootElement, emit, onClose, moveElementToBody, removeElementInBody, escapeHandler, showTabsMore, loading, currentRoundNodata, FileWrapperMultiViewInfo, FileWrapperMultiViewTabs, FileWrapperRejection, FileWrapperApplicant, PtIcon, PtNodata }
}

})